/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { MCQQuestion } from './mCQQuestion';
import type { MCQConfigInputQuestionsToShow } from './mCQConfigInputQuestionsToShow';
import type { MCQConfigInputTimeLimitMinutes } from './mCQConfigInputTimeLimitMinutes';

/**
 * MCQ config for a task.
 */
export interface MCQConfigInput {
  questions: MCQQuestion[];
  questionsToShow?: MCQConfigInputQuestionsToShow;
  passThresholdPercent?: number;
  shuffleQuestions?: boolean;
  shuffleOptions?: boolean;
  showImmediateFeedback?: boolean;
  timeLimitMinutes?: MCQConfigInputTimeLimitMinutes;
}
